import { render, staticRenderFns } from "./other.vue?vue&type=template&id=9dd88e68&"
import script from "./other.vue?vue&type=script&lang=ts&"
export * from "./other.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports